// extracted by mini-css-extract-plugin
export default {"zone":"file-dropzone_zone__WE41T","disabled":"file-dropzone_disabled__vWt3b","input":"file-dropzone_input__1a5On","dragging":"file-dropzone_dragging__ZN6Di"};